import React from 'react';
import './signup-onboarding-screen.scss';
import {
  AgentReadyModal,
  ConfirmationModal,
  MobileWhatsappSimulator,
  SimulatorScreenEnum,
  WelcomeModal,
  ZonoMoneySimulator,
} from '@zonofi/gandalf-components';
import { useSignupOnboardingScreen } from '@zonofi/gandalf-utilities';

export const SignupOnboardingScreen: React.FC = () => {
  const {
    changeToZonoMoneySimulator,
    closeConfirmationModal,
    isSampleFileLoadError,
    navigateToLaunchScreen,
    navigateToRetrainScreen,
    navigateToSignupHome,
    openConfirmationModal,
    setIsSampleFileLoadError,
    setSimulatorScreen,
    showAgentReadyModal,
    showConfirmationModal,
    showErrorStrip,
    showOnboardingDialog,
    showWelcomeModal,
    simulatorScreen,
    testAIAgent,
    trainWithSampleFile,
    viewSampleFile,
    zonoMoneyUrl,
  } = useSignupOnboardingScreen();

  return (
    <div className="signup-onboarding-screen">
      <MobileWhatsappSimulator
        changeToZonoMoneySimulator={changeToZonoMoneySimulator}
        navigateToLaunchScreen={navigateToLaunchScreen}
        navigateToRetrainScreen={navigateToRetrainScreen}
        noFrame={true}
        openConfirmationModal={openConfirmationModal}
        showErrorStrip={showErrorStrip}
        viewSampleFile={viewSampleFile}
      />
      {showOnboardingDialog && (
        <WelcomeModal
          open={showWelcomeModal}
          isSampleFileLoadError={isSampleFileLoadError}
          retrain={() => {
            setIsSampleFileLoadError(false);
            trainWithSampleFile();
          }}
        />
      )}
      {showOnboardingDialog && (
        <AgentReadyModal onClose={testAIAgent} open={showAgentReadyModal} />
      )}
      {showConfirmationModal && (
        <ConfirmationModal
          open={true}
          onExitClick={navigateToSignupHome}
          onContinueClick={closeConfirmationModal}
        />
      )}
      <ZonoMoneySimulator
        onClose={() => {
          setSimulatorScreen(SimulatorScreenEnum.WHATSAPP);
        }}
        open={simulatorScreen === SimulatorScreenEnum.ZONOMONEY}
        zonoMoneyUrl={zonoMoneyUrl}
      />
    </div>
  );
};
